import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { UpsertBillingDetailsDto } from '../../@types';

export const upsertBillingDetails = async (
  billingDetailsDto: UpsertBillingDetailsDto
): Promise<any> => {
  const response = await axiosInstance.post(
    '/api/payments/upsert-billing-details',
    billingDetailsDto
  );
  return response.data;
};

export const useUpsertBillingDetails = () => {
  return useMutation((billingDetailsDto: UpsertBillingDetailsDto) =>
    upsertBillingDetails(billingDetailsDto)
  );
};
